import { Guid } from 'guid-typescript';
import { Timestamp } from '@/db/firestore';
import { BaseModel } from './BaseModel';

export class UserAnswers extends BaseModel {
    public DeckId: string;
    public cardGuid: string;
    public userId: string;
    public consecCorrect?: number;
    public lastRating?: number;
    public lastAnswered?: any;
    public lastAnsweredClient?: any;
    public easiness?: number;
    public nextIntervalDays?: number;
    public nextIntervalDate?: firebase.firestore.Timestamp;
}
